import useSWR from "swr";
import axios from "axios";

function useBusyDates({ shouldFetch = true, labourerId }) {
  return useSWR(shouldFetch ? [`${process.env.REACT_APP_API_URL}/labourers/${labourerId}/busy-dates`] : null, async ([url]) => {
    const { data: busyDates } = await axios.get(url, {
      labourerId
    });

    return { busyDates };
  });
}

export default useBusyDates;
